/**
 * ModalContainer Component
 *
 * Main modal orchestrator that handles:
 * - Modal state management
 * - Modal type switching (Image, Metadata)
 * - TV remote control integration
 * - Component composition
 */

import React from 'react'
import { useTVRemoteControl } from '../hooks/useTVRemoteControl'
import { useModalNavigation } from '../hooks/useModalNavigation'
import ModalControls from './ModalControls'
import ImageModal from './ImageModal'
import MetadataModal from './MetadataModal'
import '../../../assets/stylesheets/modal.css'

const ModalContainer = ({ state, dispatch, onClose, props }) => {
  // Ensure props.dispatch uses the correct local dispatch
  const correctedProps = {
    ...props,
    dispatch: dispatch
  }

  const { handleModalArrowClick } = useModalNavigation()

  // TV Remote Control hook for modal navigation
  useTVRemoteControl({
    onModalArrowLeft: () => handleModalArrowClick(correctedProps, 'left'),
    onModalArrowRight: () => handleModalArrowClick(correctedProps, 'right'),
    isModalActive: state.modalActive,
    enableGalleryNavigation: false,
    enableModalNavigation: true,
    enableAssetScrolling: false,
    loadTVStyles: false
  })

  const handleOverlayClick = e => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return (
    <div
      className={`modal ${state?.modalActive ? 'active' : ''}`}
      onClick={handleOverlayClick}
    >
      <ModalInner
        state={state}
        dispatch={dispatch}
        onClose={onClose}
        props={props}
        correctedProps={correctedProps}
      />
    </div>
  )
}

const ModalInner = ({ state, dispatch, onClose, props, correctedProps }) => {
  return (
    <>
      <ModalControls
        state={state}
        dispatch={dispatch}
        onClose={onClose}
        props={correctedProps}
        showNavigationArrows={false}
      />

      <div className="modal-title">
        {/* Title can be added here if needed */}
      </div>

      <div className="modal-center">
        {/* Left Arrow */}
        {state.modalStatus === 'Image' && (
          <ModalControls
            state={state}
            dispatch={dispatch}
            onClose={onClose}
            props={correctedProps}
            showBackButton={false}
            showNavigationArrows={true}
            arrowsOnly="left"
          />
        )}

        <div className="modal-content01">
          {state.modalStatus === 'MetaData' && (
            <MetadataModal state={state} dispatch={dispatch} />
          )}
          {state.modalStatus === 'Image' && (
            <ImageModal
              state={state}
              dispatch={dispatch}
              props={correctedProps}
              onClose={onClose}
            />
          )}
        </div>

        {/* Right Arrow */}
        {state.modalStatus === 'Image' && (
          <ModalControls
            state={state}
            dispatch={dispatch}
            onClose={onClose}
            props={correctedProps}
            showBackButton={false}
            showNavigationArrows={true}
            arrowsOnly="right"
          />
        )}
      </div>

      <div className="modal-button-container01">
        {/* Additional buttons or content can be added here if needed */}
      </div>
    </>
  )
}

export default ModalContainer
